<template>
  <div>
    <b-modal
      id="login-kb-modal"
      ref="login-kb-modal-ref"
      hide-footer
      title="Login"
    >
      <b-form
        class="login-form"
        @submit.stop.prevent="onSubmit"
      >
        <div class="vtd-card-block">
          <h5 class="vtd-card-title">
            Please enter your Knowledgebase credentials.
          </h5>
          <FlashMessage />
          <b-form-group
            label="Logname"
            label-for="input-username"
            class="vtd-form-group"
          >
            <b-form-input
              id="input-username"
              v-model.trim="$v.form.username.$model"
              type="text"
              class="vtd-form-control vtd-form-control-lg "
              :state="validateState('username')"
            />
          </b-form-group>

          <b-form-group
            label="Password"
            label-for="input-password"
            class="vtd-form-group"
          >
            <b-form-input
              id="input-password"
              v-model.trim="$v.form.password.$model"
              type="password"
              class="vtd-form-control vtd-form-control-lg "
              :state="validateState('password')"
            />
          </b-form-group>

          <div class="vtd-card-footer">
            <b-button
              type="submit"
              class="vtd-btn vtd-btn-success vtd-btn-login vtd-btn-xl vtd-btn-block vtd-btn-center vtd-text-white"
            >
              Login
            </b-button>
          </div>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FlashMessage from "@/partials/flash-message"
import { mapActions } from 'vuex'

export default {
  components: {
    FlashMessage
  },
  data() {
    return {
      onSuccess: null,
      authorisedCallback: null,
      destination: null,
      form: {
        username: '',
        password: ''
      }
    }
  },
  validations: {
    form: {
      username: {
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
     validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    showModal(onSuccess){
      this.onSuccess = onSuccess
      this.$refs["login-kb-modal-ref"].show();
    },
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const res = await this.login(this.form)
      if (res) {
        this.$refs["login-kb-modal-ref"].hide();
        if (this.onSuccess) {
          this.onSuccess()
        }
      }
    },
    ...mapActions({
      login: 'staff/loginStaffAction',
    }),
  }
};
</script>

<style>
</style>
